import routerOptions0 from "/opt/simploshop/node_modules/.pnpm/nuxt@4.0.1_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler-_146d17ab30a9bf24368648cb0b07bbfb/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/opt/simploshop/shared/core-theme/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}